import { createFileRoute } from "@tanstack/react-router";
import { TaskPage } from "@/features/taskpage/TaskPage";

export const Route = createFileRoute("/_app/tasks/$key")({ component: Page });

function Page() {
  const { key } = Route.useParams();
  return <TaskPage taskKey={key} />;
}
